import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/Logo";
import { ThemeToggle } from "@/components/ThemeToggle";
import { useTheme } from "@/context/ThemeContext";
import { brandImage } from "@/lib/brand";
import { useAuth } from "@/context/AuthContext";
import { formatError } from "@/lib/api";

const mediaSrc = (u) => (u?.startsWith("http") ? u : `${process.env.REACT_APP_BACKEND_URL}${u}`);
const isVideo = (u) => /\.(mp4|mov|webm)(\?|$)/i.test(u || "");

export default function Register() {
  const { register, branding } = useAuth();
  const { theme } = useTheme();
  const nav = useNavigate();
  const [f, setF] = useState({ first_name: "", last_name: "", username: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const upd = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await register(f); toast.success("Registracija uspješna"); nav("/dashboard"); }
    catch (err) { toast.error(formatError(err)); }
    setBusy(false);
  };

  const bg = brandImage(branding, theme, "register_bg") || "";

  return (
    <div className="stream-dark min-h-screen flex items-center justify-center px-4 py-8 sm:py-10 relative overflow-hidden">
      {bg && (isVideo(bg) ? (
        <video src={bg} autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover z-0" data-testid="register-bg-video" />
      ) : (
        <img src={bg} alt="" className="absolute inset-0 w-full h-full object-cover z-0" data-testid="register-bg" />
      ))}
      {bg && <div className="absolute inset-0 bg-black/10 z-0" />}
      <div className="w-full max-w-md relative z-10">
        <div className="flex justify-end mb-3"><ThemeToggle /></div>
        <Link to="/" className="flex justify-center mb-6 sm:mb-8"><Logo size="xl" light /></Link>
        <div className="card-dark p-6 sm:p-8 backdrop-blur-xl bg-[#171717]/85 border-white/10">
          <h1 className="font-heading font-black text-2xl sm:text-3xl text-white mb-2">Registracija</h1>
          <p className="text-white/60 mb-8">Kreirajte STRE PAY račun</p>
          <form onSubmit={submit} className="space-y-4">
            <div className="grid grid-cols-2 gap-3">
              <div>
                <Label className="text-white/80">Ime</Label>
                <Input value={f.first_name} onChange={upd("first_name")} required className="mt-2 bg-white/5 border-white/10 text-white h-11 rounded-xl" data-testid="reg-first" />
              </div>
              <div>
                <Label className="text-white/80">Prezime</Label>
                <Input value={f.last_name} onChange={upd("last_name")} required className="mt-2 bg-white/5 border-white/10 text-white h-11 rounded-xl" data-testid="reg-last" />
              </div>
            </div>
            <div>
              <Label className="text-white/80">Username</Label>
              <Input value={f.username} onChange={upd("username")} required className="mt-2 bg-white/5 border-white/10 text-white h-11 rounded-xl" data-testid="reg-username" />
            </div>
            <div>
              <Label className="text-white/80">Email</Label>
              <Input type="email" value={f.email} onChange={upd("email")} required className="mt-2 bg-white/5 border-white/10 text-white h-11 rounded-xl" data-testid="reg-email" />
            </div>
            <div>
              <Label className="text-white/80">Lozinka</Label>
              <Input type="password" value={f.password} onChange={upd("password")} required minLength={6} className="mt-2 bg-white/5 border-white/10 text-white h-11 rounded-xl" data-testid="reg-password" />
            </div>
            <Button type="submit" disabled={busy} className="btn-yellow w-full h-12 rounded-xl mt-2" data-testid="reg-submit">
              {busy ? "Registracija…" : "REGISTRIRAJ SE"}
            </Button>
          </form>
          <p className="mt-6 text-center text-sm text-white/60">Već imate račun? <Link to="/login" className="text-[#FFD60A]" data-testid="link-login">Prijavite se</Link></p>
        </div>
        <p className="text-center text-white/40 text-xs mt-5">
          <span className="privacy-pill">Registracijom prihvaćate <Link to="/privacy" className="hover:text-[#FFD60A] underline" data-testid="register-privacy-link">Politiku privatnosti</Link></span>
        </p>
      </div>
    </div>
  );
}
